const Close = () => {
  return (
    <>
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.5672 10.0008L20.6672 1.90075C20.8492 1.6882 20.9443 1.41478 20.9335 1.13514C20.9227 0.855498 20.8068 0.590233 20.6089 0.39235C20.411 0.194467 20.1457 0.0785416 19.8661 0.0677403C19.5865 0.0569391 19.313 0.152057 19.1005 0.334087L11.0005 8.43409L2.90049 0.322975C2.68793 0.140946 2.41451 0.0458288 2.13487 0.05663C1.85523 0.0674313 1.58997 0.183356 1.39208 0.381239C1.1942 0.579121 1.07827 0.844387 1.06747 1.12403C1.05667 1.40367 1.15179 1.67708 1.33382 1.88964L9.43382 10.0008L1.32271 18.1008C1.2064 18.2004 1.11193 18.3229 1.04524 18.4608C0.978543 18.5986 0.941065 18.7488 0.935154 18.9018C0.929244 19.0548 0.955028 19.2074 1.01089 19.35C1.06675 19.4926 1.15148 19.6221 1.25976 19.7304C1.36805 19.8386 1.49754 19.9234 1.64013 19.9792C1.78271 20.0351 1.9353 20.0609 2.08832 20.055C2.24134 20.0491 2.39149 20.0116 2.52934 19.9449C2.66719 19.8782 2.78977 19.7837 2.88937 19.6674L11.0005 11.5674L19.1005 19.6674C19.313 19.8495 19.5865 19.9446 19.8661 19.9338C20.1457 19.923 20.411 19.807 20.6089 19.6092C20.8068 19.4113 20.9227 19.146 20.9335 18.8664C20.9443 18.5867 20.8492 18.3133 20.6672 18.1008L12.5672 10.0008Z"
          fill="black"
        />
      </svg>
    </>
  );
};

export default Close;
